<mat-toolbar>
  <mat-icon>slow_motion_video</mat-icon>
  µ Global Controls
</mat-toolbar>

<mat-tab-group>
  <mat-tab label="Secure Access CRUD">
    <micro-global-on-off-control controlType="SA_CRUD_BLOCK"
                                 controlName="Secure Access CRUD"
                                 onLabel="Block"
                                 offLabel="Unblock"
                                 onColor="#ea0000"
                                 offColor="#4ab000"
    >

    </micro-global-on-off-control>
  </mat-tab>
  <mat-tab label="TauLock App">
    <micro-global-value-control controlType="SA_TAULOCK_APP_VERSION"
                                controlName="TauLock App Version"
                                valuePlaceholder="As displayed in footer of app ie. 1.20 (428)"
                                [valueNote]="'Specify the version of each platform: <br/>\n' +
                                             '<i>all:1.20 (427); ios:1.20 (427); android-play:1.20 (430); android-apk:1.20 (430)</i>'"
                                [descriptionPlaceholder]="'This message will be displayed to the app user and can contain HTML markup.'"
                                [descriptionNote]="'Default message:<br/>' +
                                                   'A new version of TauLock is available. Use <b>Upgrade now</b> for upgrade options'"
                                [descriptionOptional]="true"
                                confirmMessage="Please confirm that this version is already available<br/>on the Apple and Google app stores and APK download."
                                confirmButtonText="Confirm"
    >
    </micro-global-value-control>
    <div style="margin-top: 10px;">
      <micro-global-value-control controlType="SA_TAULOCK_APP_UPG_URL"
                                  controlName="TauLock App Upgrade URL"
                                  valuePlaceholder="https://lock.taulite.co.za"
                                  descriptionPlaceholder=""
                                  confirmMessage="Please confirm that this URL is publicly available and working"
                                  confirmButtonText="Confirm"
      >
      </micro-global-value-control>
    </div>
  </mat-tab>
</mat-tab-group>
